import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileBase64 from 'react-file-base64';
import { resizeImage } from 'function/resizeImage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SubCard from 'ui-component/cards/SubCard';
import {
    Alert,
    Avatar,
    Box,
    Button,
    ButtonBase,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Collapse,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputBase,
    InputLabel,
    MenuItem,
    Pagination,
    Paper,
    Select,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import axios from 'axios';
import ApiLink from 'API';
import { useTheme } from '@mui/styles';
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PanoramaIcon from '@mui/icons-material/Panorama';
import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router';
import InvoicePDFCustomer from './InvoicePDFCustomer';
const ViewReceipt = ({ Open, setOpen, DataInvoice }) => {
    const handleClose = () => {
        setOpen(false);
    };
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (Open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [Open]);
    const theme = useTheme();
    const navigate = useNavigate();
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });
    return (
        <div>
            <Dialog
                // fullScreen
                fullWidth
                maxWidth="md"
                open={Open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle1">Preview Invoice {DataInvoice.invoiceNumber}</Typography>
                    <Box></Box>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ minHeight: '75vh', maxHeight: '75vh', mb: 2 }}>
                    <Collapse in={AlertBox.open}>
                        <Alert
                            sx={{ padding: '10px' }}
                            // variant="outlined"
                            severity={AlertBox.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertBox({ ...AlertBox, open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {AlertBox.message}
                        </Alert>
                    </Collapse>
                    <DialogActions
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        sx={{ display: 'flex', justifyContent: 'flex-start' }}
                    >
                        <Grid container spacing={1}>
                            <InvoicePDFCustomer data={DataInvoice} />
                        </Grid>
                    </DialogActions>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box></Box>

                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button onClick={handleClose}>Save</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ViewReceipt;
